import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '@shared/shared.module';
import { AppRoutingModule } from '../../app-routing.module';
import { BannerComponent } from './banner.component';
import { UserDropdownComponent } from './user-dropdown/user-dropdown.component';
import { PipesModule } from '../../shared/pipes/pipes.module';

@NgModule({
  declarations: [
    BannerComponent,
    UserDropdownComponent
  ],
  imports: [
    CommonModule,
    AppRoutingModule,
    PipesModule,
    SharedModule
  ],
  exports: [
    BannerComponent,
  ]
})
export class BannerModule { }
